import React from "react"
import "./style.css"
import { Col, Container, Row } from "react-bootstrap"
import { Link } from "react-router-dom"

const Footer = () => {
  
  return (
    <footer>
        <Container>
          <Row className="footer-row">
            <Col md={3} sm={5} className='box'>
              <div className="logo">
                  <ion-icon name="bag"></ion-icon>
                  <h1>Bulky</h1>
              </div>
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Auctor libero id et, in gravida. Sit diam duis mauris nulla cursus. Erat et lectus vel ut sollicitudin elit at amet.</p>
            </Col>
            <Col md={3} sm={5} className='box'>
              <h2>About Us</h2>
              <ul>
                <li><Link className="link" to="/careers">Careers</Link></li>
                <li><Link className="link" to="/ourstores">Our Stores</Link></li>
                <li><Link className="link" to="/ourcares">Our Cares</Link></li>
                <li><Link className="link" to="/terms-conditions">Terms & Conditions</Link></li>
                <li><Link className="link" to="/privacy-policy">Privacy Policy</Link></li>
              </ul>
            </Col>
            <Col md={3} sm={5} className='box'>
              <h2>Customer Care</h2>
              <ul>
              <li><Link className="link" to="/helpcenter">Help Center</Link></li>
                <li><Link className="link" to="/howtobuy">How to Buy</Link></li>
                <li><Link className="link" to="/trackorder">Track Your Order </Link></li>
                <li><Link className="link" to="/businesspurchasing">Corporate & Bulk Purchasing</Link></li>
                <li><Link className="link" to="/returnrefunds">Returns & Refunds </Link></li>
              </ul>
            </Col>
            <Col md={3} sm={5} className='box'>
              <h2>Contact Us</h2>
              <ul>
                <li>70 Washington Square South, New York, NY 10012, United States </li>
                <li>Email: uilib.help@gmail.com</li>
                <li>Phone: +1 1123 456 780</li>
              </ul>
            </Col>
          </Row>
        </Container>
    </footer>
  )
}

export default Footer
